module.exports = __webpack_public_path__ + "img/magnataur_small.1de480c0.png";